function TransitionMeta(action, from, to)
{
    this.action = action;
    this.from = from;
    this.to = to;
}

export default TransitionMeta;



// WEBPACK FOOTER //
// ./src/core/parsers/TransitionMeta.js